import { Phone, MessageCircle } from "lucide-react";
import { SITE } from "@/data/site";

export default function FloatingActions() {
  return (
    <div className="fixed right-4 md:right-6 bottom-5 md:bottom-8 z-40 flex flex-col gap-3">
      <a
        href={SITE.whatsappHref}
        target="_blank" rel="noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="floating-whatsapp"
        className="w-14 h-14 rounded-full grid place-items-center text-white shadow-lg"
        style={{ background: "#25D366" }}
      >
        <MessageCircle size={22}/>
      </a>
      <a
        href={SITE.telHref}
        aria-label={`Call ${SITE.phone}`}
        data-testid="floating-call"
        className="w-14 h-14 rounded-full grid place-items-center text-white shadow-lg"
        style={{ background: "#C5A059" }}
      >
        <Phone size={20}/>
      </a>
    </div>
  );
}
